import { actionTypes } from '@/core/constants'

export default {
	methods: {
		async atualizarSessaoComOOrgao(idOrgao) {
			await this.$store.dispatch(actionTypes.COMUM.ATUALIZAR_SESSAO, idOrgao)
		},
	},
}
